export const SORT_STATUS = {
  ASCENDING: 1,
  DESCENDING: 0,
};

export const RESERVATION_STATUS = {
  CONFIRMED: "CONFIRMED",
  CREATED: "CREATED",
  IN_PROGRESS: "IN_PROGRESS",
  CANCELED:"CANCELED",
  ARCHIVED: "ARCHIVED",
  PASSED: "PASSED"
};

export const ESTABLISHMENT_STATUS = {
  MISSING_INFORMATIONS: "MISSING_INFORMATIONS",
  WAITING_FOR_APPROVAL: "WAITING_FOR_APPROVAL",
  ACTIVATED: "ACTIVATED",
  DISABLED: "DISABLED",
};

export const ORGANISME_STATUS = {
  MISSING_INFORMATIONS: "MISSING_INFORMATIONS",
  COMPLETED: "COMPLETED",
};

export const PARTNER_TYPE = {
  TRAVEL_SERVICE: "TRAVEL_SERVICE",
  ACCOMMODATION_SERVICE: "ACCOMMODATION_SERVICE",
};

export const USER_STATUS = {
  ACTIVATION_IN_PROGRESS: "ACTIVATION_IN_PROGRESS",
  MISSING_INFORMATIONS: "MISSING_INFORMATIONS",
  ACTIVATED: "ACTIVATED",
};

export const LEGAL_STATUS = {
  EI: "EI",
  SA: "SA",
  SARL: "SARL",
  SAS: "SAS",
  SCS: "SCS",
  SCA: "SCA",
  SEP: "SEP",
  SNC: "SNC",
  GIE: "GIE",
};

export const USER_ROLE = {
  PSA: "PSA",
  PA: "PA",
  PU: "PU",
  AFFECTED: "AFFECTED",
};

export const UPLOAD_RESOURCES = {
  PERSON: "PERSON",
  PARTNER: "PARTNER",
  HOST: "HOST",
  TRIP: "TRIP",
};

export const UPLOAD_TYPES = {
  PHOTO: "PHOTO",
  SUPPORTING_DOCUMENT: "SUPPORTING_DOCUMENT",
  ID: "ID",
};

export const USER_TYPES = {
  PRO: "PRO",
  PART: "PART",
};

export const ATTACHMENT_ACTION = {
  EDITED: "EDITED",
  CREATED: "CREATED",
  DELETED: "DELETED",
};

export const ENTITY_TYPE = {
  ORGANIZATION: "ORGANIZATION",
  ESTABLISHMENT: "ESTABLISHMENT",
};
